import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { createDisplayLink } from '../../../../../../../../services/helper';
import VyModal from '../../../../../../../common/VyModal';
import Link from 'next/link';

const ContactShareFilesModal = ({ files, onClose }: { files: string[]; onClose: () => void }) => {
  return (
    <VyModal open={true} onClose={onClose}>
      {() => (
        <div className="flex w-full">
          {files &&
            files.map((file, index) => (
              <Link href={createDisplayLink(file, false, undefined, undefined, undefined, false)} className="flex flex-col items-center mx-2" target="_blank">
                <SystemUpdateAltIcon fontSize="large" />
                <span>{index}</span>
              </Link>
            ))}
        </div>
      )}
    </VyModal>
  );
};
export default ContactShareFilesModal;
